<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="calibre_pb_0">
<span id="Page_iii" title="[iii]"></span>
<h2 class="nobreak" id="pgepubid00001">PREFACE</h2>
</div>
<p class="calibre3">“<span class="smcap">With Washington in the West</span>” is a complete
story in itself, but forms the first of several
volumes to be known by the general title of “Colonial
Series.”</p>
<p class="calibre3">The main character of the book is David Morris,
the son of a hardy pioneer who first settles near Will’s
Creek (now the town of Cumberland, Virginia),
and later on establishes a trading-post on one of the
numerous tributaries of the Ohio River.</p>
<p class="calibre3">As a boy David becomes acquainted with George
Washington, then but a young man of seventeen.
Washington is at work, surveying tracts of land in
the beautiful Shenandoah valley, and David is glad
enough to go with him as an assistant. Together
they ford the rivers and creeks, and climb the mountains,
and they do not separate until the ill health of
Lawrence Washington compels his brother to return
home.</p>
<p class="calibre3">The coming of the English traders into the valley
of the Ohio was viewed with suspicion by the French,
and it was not long before these traders were served
with notices to quit. A notice reaching Mr. Morris,<span id="Page_iv" title="[iv]"></span>
he turned it over to his son, who was to take it
to the Virginia authorities and learn whether or not
it must be respected. On his way eastward David
falls in with the Virginia Rangers, who are under
the command of Washington, and learns that there
is practically a state of war between the English and
French in America. Several trading-posts have been
attacked and this being so the youth becomes anxious
to return to his father, and throws in his fortunes
with Washington as a young soldier. Then follows
the march to Great Meadows, the defence of Fort
Necessity, and the news that Mr. Morris’ post has
been captured by the French and the trader taken
prisoner.</p>
<p class="calibre3">Chafing to learn what has become of his parent,
David remains at the home of his uncle until the
next Spring, when General Braddock arrives with his
troops from England. Another campaign against
the French is now opened and once again the youth
becomes a soldier boy, to witness Braddock’s bitter
defeat and Washington’s masterly effort to save the
remnant of the army from annihilation.</p>
<p class="calibre3">In the preparation of the historical portions of this
work numerous authorities have been consulted, including
the Writings of Washington, biographies by
a great number of more or less well-known authors,
and several colonial histories and books of record.<span id="Page_v" title="[v]"></span>
For this reason the author trusts that it is free from
any error sufficient to hurt its usefulness. As a
story the writer hopes it will find equal favor with
the many which have preceded it from his pen.</p>
<p class="right"><span class="smcap">Edward Stratemeyer.</span></p>
<p class="calibre3"><span class="smcap">Newark, N. J.</span>,<br class="calibre5"/>
   <i class="calibre12">May 20, 1901</i>.</p>
<p class="calibre3"><span id="Page_vi" title="[vi]"></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?47a79b96